import { assetAllocationPages } from "@app/const/route.const";
import { useSearchParams } from "react-router-dom";
import { ModuleSimulatedForwardProbabilitiesReport } from "@app/pages/portfolioAnalysis/pdfSimulatedForwardProbabilitiesReportPage/ModuleSimulatedForwardProbabilitiesReport";

export const PdfAssetAllocationModuleSimulatedForwardProbabilitiesReportPage =
  () => {
    const [searchParams] = useSearchParams();
    const {
      portfolioGroupId,
      moduleId,
      data1Id,
      data2Id,
      isReal,
      isCompare,
      chartDateRange1,
      chartDateRange2,
    } =
      assetAllocationPages.getPdfModuleSimulatedForwardProbabilitiesReportParams(
        searchParams,
      );

    return (
      <ModuleSimulatedForwardProbabilitiesReport
        portfolioGroupId={portfolioGroupId}
        moduleId={moduleId}
        data1Id={data1Id}
        data2Id={data2Id}
        isReal={isReal}
        isCompare={isCompare}
        chartDateRange1={chartDateRange1}
        chartDateRange2={chartDateRange2}
        footer="Asset Allocation"
      />
    );
  };
